
import { Component, Input, OnChanges, Output, EventEmitter, ViewChild, ElementRef, AfterViewInit } from '@angular/core';

import { FieldTypeListParentService } from './../utils/field-type-list-parent.service';
import { ByWordPipe } from '../../../filters/by-word/by-word.pipe';
import { AfOrderByPipe } from '@shared/filters/af-order-by/af-order-by.pipe';
import { AfTranslateDirective } from '../../../modules/translate/directive/af-translate.directive';
import { SpanTooltipComponent } from '../../span-tooltip/span-tooltip.component';
import { NgClass, NgStyle } from '@angular/common';
import { FieldSequentialHeaderComponent } from '@shared/components/field-sequential-header/field-sequential-header.component';
import { OverlayPanel, OverlayPanelModule } from 'primeng/overlaypanel';


@Component({
  selector: 'field-type-list-sequential',
  templateUrl: './field-type-list-sequential.component.html',
  standalone: true,
  imports: [
    NgClass,
    NgStyle,
    SpanTooltipComponent,
    AfTranslateDirective,
    AfOrderByPipe,
    ByWordPipe,
    FieldSequentialHeaderComponent,
    OverlayPanelModule
  ]
})

export class FieldTypeListSequentialComponent implements OnChanges, AfterViewInit {
  selectionAsArray:boolean = false;
  isLanding = true;
  fieldTypeList:any = this.fieldTypeListParent.configureFieldTypeList(this);
  constructor( private fieldTypeListParent: FieldTypeListParentService) {}

  @Input() field:any = null;
  @Input() preSelectItem:any = '';
  @Input() listValues:any = [];
  @Input() listAll:any = [];
  @Input() public: boolean = false;
  @Input() type:any = '';
  @Input() orderBy:any;
  @Input() fieldToFind: string = 'text';
  @Output() itemSelected = new EventEmitter();
  @ViewChild('containerFieldList') containerFieldListElement: ElementRef;
  @ViewChild('fieldTypeListSequentialOverlay') fieldTypeListSequentialOverlay: OverlayPanel;

  ngAfterViewInit(): void {
    this.fieldTypeListParent.configureAfterViewInit(this.fieldTypeListSequentialOverlay);
  }

  ngOnChanges(): void {
    this.fieldTypeListParent.configureChanges(this);
  }

  toggleFilter(e: any){
    this.fieldTypeListParent.toggleFilter(e, this.fieldTypeListSequentialOverlay, this);
  }

  closeList(){
    this.fieldTypeListParent.closeList(this);
  }

  checkListValue(listValue:any){
    return !(listValue?.type?.toLowerCase()==='back' && !listValue.show);
  }

  addOrDeleteSelectedValue(listValue:any){
    if(!listValue.disabled){
      // this.fieldTypeList.markAll = false;
      if(this.field.multiple){
        this.fieldTypeListParent.addOrDeleteSelectedValue(listValue, this);
      }else{
        this.fieldTypeListParent.selectItem(listValue, this);
        if(listValue.selected){
          this.fieldTypeListSequentialOverlay.hide();
        }
      }
    }
  }
}
